import { useAuthStore } from '../store/authStore';
import { AUTH_BASE_URL } from './api';

const TENANT_ID = process.env.REACT_APP_TENANT_ID;

function getResponseMessage(data, fallback) {
  if (typeof data === 'string' && data) {
    return data;
  }

  if (typeof data === 'object' && data !== null) {
    return data.message || data.mensaje || data.error || fallback;
  }

  return fallback;
}

function normalizeMessage(message) {
  return String(message || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  return response.text();
}

async function authRequest(path, body) {
  const response = await fetch(`${AUTH_BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'X-Tenant-ID': TENANT_ID || '',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  console.log("🚀 ~ authService.js:44 ~ authRequest ~ response:", TENANT_ID)

  const data = await parseResponse(response);

  if (!response.ok) {
    const error = new Error(getResponseMessage(data, response.statusText));
    error.status = response.status;
    error.data = data;
    throw error;
  }

  if (typeof data === 'object' && data !== null && 'estado' in data && data.estado !== 1) {
    const error = new Error(getResponseMessage(data, 'La solicitud no pudo completarse.'));
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export function mapSolicitarOTPError(error) {
  const message = error.message;
  const normalizedMessage = normalizeMessage(message);

  if (error.status === 400 && normalizedMessage === 'email requerido') {
    return 'El email es requerido';
  }

  if (error.status === 400 && normalizedMessage === 'tenant no identificado') {
    return 'Error de configuración. Contactá al administrador.';
  }

  if (
    error.status === 400 &&
    normalizedMessage === 'este mail no pertenece a la empresa'
  ) {
    return 'Este email no está registrado en el sistema';
  }

  if (
    error.status === 403 &&
    normalizedMessage ===
      'usted no tiene permisos de evaluador para esta aplicacion'
  ) {
    return 'No tenés permisos para acceder a esta aplicación';
  }

  return message || 'No se pudo enviar el código.';
}

export function mapVerificarOTPError(error) {
  const message = error.message;
  const normalizedMessage = normalizeMessage(message);

  if (
    error.status === 401 &&
    normalizedMessage.startsWith('codigo incorrecto. te quedan')
  ) {
    return {
      message,
      canRequestNewCode: false,
    };
  }

  if (
    error.status === 401 &&
    normalizedMessage === 'el codigo expiro. solicita uno nuevo'
  ) {
    return {
      message: 'El código expiró. Volvé a solicitar uno nuevo.',
      canRequestNewCode: true,
    };
  }

  if (
    error.status === 429 &&
    normalizedMessage === 'demasiados intentos. solicita un nuevo codigo'
  ) {
    return {
      message: 'Demasiados intentos fallidos. Solicitá un nuevo código.',
      canRequestNewCode: true,
    };
  }

  return {
    message: message || 'No se pudo verificar el código.',
    canRequestNewCode: false,
  };
}

export async function solicitarOTP({ email }) {
  return authRequest('/login/solicitar', { email });
}

export async function verificarOTP({ email, otp }) {
  return authRequest('/login/verificar', { email, otp });
}

export function logout() {
  useAuthStore.getState().clearSession();
}
